import { getPercent } from '@/shared/lib/getPercent';
import { Status } from '@/shared/types/Status';

import {
  DETERMINING_SPEAKERS_SEC,
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  PROJECT_CREATED_TO_UPLOADING_SEC,
  SEPARATE_BACKGROUND_SEC,
  SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC,
  TRANSLATION_SEC,
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_SEC,
  VOICE_SUGGESTING_SEC,
  VOICE_SUGGESTING_TO_TRANSLATION_SEC,
} from './mlAverageTasksDurations';

export const VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO =
  PROJECT_CREATED_TO_UPLOADING_SEC +
  VIDEO_UPLOADING_SEC +
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
  VOICE_SUGGESTING_SEC +
  VOICE_SUGGESTING_TO_TRANSLATION_SEC +
  TRANSLATION_SEC;
const INITIAL_PERCENT = 1;
const FINAL_PERCENT = 99;
// Рассчитанные начальные проценты для каждого статуса загрузки видео
const PROJECT_UPLOADING_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_UPLOADING_TO_SEPARATE_BACKGROUND_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_SEPARATE_BACKGROUND_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC + VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const DETERMINE_SPEAKERS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const VOICE_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
    VOICE_SUGGESTING_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
const TRANSLATION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
    VOICE_SUGGESTING_SEC +
    VOICE_SUGGESTING_TO_TRANSLATION_SEC,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
);
// Константы для загрузки видео
export const VIDEO_WITH_SRC_SRT_UPLOADING_TASKS_SEC: {
  [key in Status]?: number;
} = {
  [Status.created]: PROJECT_CREATED_TO_UPLOADING_SEC,
  [Status.determineSpeakersDone]: DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  [Status.determineSpeakersStarted]: DETERMINING_SPEAKERS_SEC,
  [Status.separateBackgroundDone]: SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_SEC,
  [Status.separateBackgroundStarted]: SEPARATE_BACKGROUND_SEC,
  [Status.translationStarted]: TRANSLATION_SEC,
  [Status.uploaded]: VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  [Status.uploading]: VIDEO_UPLOADING_SEC,
  [Status.voiceSuggestDone]: VOICE_SUGGESTING_TO_TRANSLATION_SEC,
  [Status.voiceSuggestStarted]: VOICE_SUGGESTING_SEC,
};
export const INITIAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_STATUS: {
  [key in Status]?: number;
} = {
  [Status.created]: INITIAL_PERCENT,
  [Status.determineSpeakersDone]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.separateBackgroundDone]: SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_INITIAL_PERCENT,
  [Status.separateBackgroundStarted]: PROJECT_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.translationStarted]: TRANSLATION_INITIAL_PERCENT, // 92
  [Status.uploaded]: PROJECT_UPLOADING_TO_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.uploading]: PROJECT_UPLOADING_INITIAL_PERCENT,
  [Status.voiceSuggestDone]: VOICE_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: VOICE_SUGGEST_INITIAL_PERCENT,
};
export const FINAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_STATUS: {
  [key in Status]?: number;
} = {
  [Status.created]: PROJECT_UPLOADING_INITIAL_PERCENT,
  [Status.determineSpeakersDone]: VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.separateBackgroundDone]: DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.separateBackgroundStarted]: SEPARATE_BACKGROUND_TO_DETERMINING_SPEAKERS_INITIAL_PERCENT,
  [Status.translationStarted]: FINAL_PERCENT, // 99
  [Status.uploaded]: PROJECT_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.uploading]: PROJECT_UPLOADING_TO_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.voiceSuggestDone]: TRANSLATION_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: VOICE_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT,
};
